import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Table, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";

function TableWidget(props) {
  const [dataSource, setDataSource] = useState([]);
  const { dataList, onUpdateAction, onDeleteAction } = props;

  useEffect(() => {
    if (dataList !== undefined) {
      setDataSource([...dataList.map((info) => ({ ...info, key: info.id }))]);
    }
  }, [dataList]);
  if (dataList === undefined) return <div />;

  const columns = [
    {
      title: "Zone",
      dataIndex: "name",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 600 }}>{text}</div>
          <div style={{ color: "var(--darkGreyColor)", fontSize: 12 }}>{record.method_label}</div>
        </div>
      ),
    },
    {
      title: "Countries",
      dataIndex: "countries_list",
      render: (list) => (Array.isArray(list) && list.length > 0 ? list.join(", ") : "-"),
    },
    {
      title: "Brackets",
      dataIndex: "brackets",
      align: "center",
      render: (brackets) => (Array.isArray(brackets) ? brackets.length : 0),
    },
    {
      title: "Max weight",
      dataIndex: "max_weight_g",
      align: "center",
      render: (t) => `${t} g`,
    },
    {
      title: "Surcharge",
      dataIndex: "surcharge_enabled",
      align: "center",
      render: (t, record) => (t === "1" ? `${record.surcharge_label} (+${record.surcharge_amount})` : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (t) => <Tag color={t === "1" ? "green" : "default"}>{t === "1" ? "Active" : "Disabled"}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => (
        <div>
          <a style={{ color: "var(--blueColor)", marginLeft: 12 }} onClick={() => onUpdateAction(record)}>
            Edit
          </a>
          <a
            style={{ color: "var(--redColor)", marginLeft: 16 }}
            onClick={async () => {
              const res = await showConfirmDlgWidget({
                title: "Delete Confirmation",
                content: `Delete the "${record.name}" shipping zone? This can't be undone.`,
              });
              if (res == false) return;
              onDeleteAction(record);
            }}
          >
            Delete
          </a>
        </div>
      ),
    },
  ];

  return (
    <div className="list-table">
      <Table pagination={false} columns={columns} dataSource={dataSource} />
    </div>
  );
}

export default withRouter(TableWidget);
